import React from 'react';
import logomarkOat from '../img/LOGOMARK-OAT.png';
import heroVideo from '../img/AIDEA AGENCY - WEB VIDEO.mp4';

const Hero = ({ onNavigate, isActive, destinationAfterVideo = 'navigation' }) => {
  return (
    <section
      id="hero"
      className={`page ${isActive ? 'active' : ''}`}
      onClick={() => onNavigate(destinationAfterVideo)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onNavigate(destinationAfterVideo);
        }
      }}
    >
      <video
        className="hero-video"
        autoPlay
        muted
        playsInline
        onEnded={() => onNavigate(destinationAfterVideo)}
      >
        <source src={heroVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="video-overlay"></div>
      <div className="nav-center hero-center">
        <img src={logomarkOat} alt="AIDEA logo" className="nav-logo" />
        <h2 className="brand-name">AIDEA</h2>
        <p className="brand-tagline">AGENCY</p>
      </div>
    </section>
  );
};

export default Hero;
